module.exports = "/_next/static/images/zonnepanelen-e04845312d2b86955202141c5d46e032.jpg";